/* Load the existing artist reel after initial page loading; keep its poster,
   dimensions and native reduced-motion choice intact. */
(function () {
  'use strict';
  var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function upgrade() {
    if (motion.matches) return;
    document.querySelectorAll('source[data-ppa-animated-logo]').forEach(function (source) {
      var image = source.parentElement.querySelector('img');
      if (image) image.setAttribute('fetchpriority', 'low');
      source.setAttribute('srcset', source.getAttribute('data-ppa-animated-logo'));
      source.removeAttribute('data-ppa-animated-logo');
    });
  }
  function schedule() {
    if ('requestIdleCallback' in window) window.requestIdleCallback(upgrade, { timeout: 1500 });
    else window.setTimeout(upgrade, 120);
  }
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
  document.addEventListener('shopify:section:load', schedule);
  if (motion.addEventListener) motion.addEventListener('change', schedule);
})();
